const listColumn = {
  TICKER: 'ticker',
  VOLUME: 'volume',
  PRICE: 'price',
  PERCENT_PRICE_CHANGE: 'percentPriceChange',
  RTD11: 'financial.rtd11',
  PE: 'financial.rtd21',
  PB: 'financial.rtd25',
  BETA: 'financial.rtd19',
  RANKING: 'rank',
  TOTAL_RANK: 'totalRank',
  HIGH_PRICE: 'ceilingPrice',
  LOW_PRICE: 'floorPrice',
  REF_PRICE: 'referencePrice',
};

const listHideColumn = [
  'ceilingPrice',
  'floorPrice',
  'referencePrice',
  'totalRank',
];

export default {
  listColumn,
  listHideColumn,
};
